import React, { useContext } from 'react'
import Link from '../Nav/Link'
import BackButton from '../Nav/BackButton'
import Title from '../Nav/Title'
import SelectSizes from '../Nav/SelectSizes'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import useMultilineText from '../hooks/useMultilineText'
import DownloadExtensionButton from '../Nav/DownloadExtensionButton'
import { EasybakeContext } from '../EasybakeProvider'

export default function NavSmartObject () {
    const { page } = useContext(EasybakeContext)
    const summary = useMultilineText(__('bannerreflow_nav_summary'))
    const instruction = useMultilineText(__('bannerreflow_nav_instruction'))
    return (
        <div className="adobe-easybake-nav feature">
            <BackButton className="adobe-easybake-nav-back-button"/>
            <div className="adobe-easybake-nav-content">
                <Title title={__('bannerreflow_nav_title')} />
                <div className="summary">
                    {summary}
                </div>
                <div className="adobe-easybake-nav-links">
                    <Link className="adobe-easybake-nav-link" referrer={`demovideo:${page}:nav`} label={__('link_demo_video')} url={__('url_demo_video_bannerreflow')} />
                </div>
                <div className="adobe-easybake-nav-button">
                    <DownloadExtensionButton referrer={page}/>
                </div>
                <div>
                    {instruction}
                </div>
            </div>
            <div className="adobe-easybake-nav-actions">
                <SelectSizes group="bannerreflow" action="selectsize" referrer={page} />
            </div>
            <br />
            <br />
        </div>
    )
}
